const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/relative.ts';
import { KisApiAction } from '@cistec/common_web/defs/actionTypes';
import { loadPatientDataForFall, REQUEST_ACTION_TYPES_LOAD_RELATIVES } from 'App/actions/relative';
import {
    getData,
    getDataFromPayloadWithListObject,
    makeReducer2,
    useRemoteData2,
} from '@cistec/common_web/utils/redux4Requests';
import { sortObjectsByPath } from '@cistec/common_web/utils/data';
import { KeyValuePair } from '@cistec/common_web/defs/generalDefs';
import { PatAppStoreState } from './setup/rootReducer';

const KEY_PATIENT_DATA_FOR_FALL = 'patientDataForFall';

export const relativesReducer = makeReducer2([
    [
        REQUEST_ACTION_TYPES_LOAD_RELATIVES,
        (action: KisApiAction) => [KEY_PATIENT_DATA_FOR_FALL, action.meta.fallNr],
        // For some reason a List is returned; we just take the first one...
        (action: KisApiAction) => getDataFromPayloadWithListObject(action)[0],
    ],
]);

// SELECTORS

// ReferencePersons = Bezugspersonen
const makeSelectRelatives = (fallNr: string) => (state: PatAppStoreState) => {
    const patientData = getData(state.relatives, [KEY_PATIENT_DATA_FOR_FALL, fallNr]);
    if (patientData && patientData?.Bezugspersonen) {
        const referencePersons = Object.values(patientData.Bezugspersonen);
        const objectKeys = referencePersons.map((person: KeyValuePair) => person.ObjectKey);
        return objectKeys.sort(sortObjectsByPath('RANGFOLGE'));
    }
    return undefined;
};

// HOOKS

export function useRelatives(fallNr: string) {
    return useRemoteData2('relatives', {
        canRequest: !!fallNr,
        request: dispatch => dispatch(loadPatientDataForFall(fallNr)),
        select: makeSelectRelatives(fallNr),
        keys: [KEY_PATIENT_DATA_FOR_FALL, fallNr],
    });
}
